import { atom } from 'jotai';

export const lastCompositionEndAtom = atom<number | undefined>(undefined);
